function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M10 5.253c-.65 0-1.212-.373-1.484-.916a2.982 2.982 0 01-.174-1.019v-.994a1.658 1.658 0 013.316 0v.994c0 .367-.063.712-.175 1.019A1.657 1.657 0 0110 5.253zm5.355 8.202L20 16.357c-.242.386-.589.535-1.23.324l-.144-.058-1.698-.686-1.872-.756a.862.862 0 01-.127-.065l-.694-.433a.804.804 0 01-.153-.127l-.005-.006a.833.833 0 01-.086-.106c-.017-.024-.03-.051-.045-.078-.009-.017-.02-.034-.027-.052-.004-.008-.01-.015-.012-.023l-1.18-2.798-.307 1.421v1.578l.452 1.663 2.348-.01 3.076.74c.022.057.045.113.059.173a1.198 1.198 0 01-.899 1.437l-1.5.346c.518.133.902.6.902 1.159H3.078c0-.558.385-1.026.902-1.159l-1.5-.346a1.198 1.198 0 01-.898-1.437c.013-.056.033-.109.053-.162l3.12-.752 2.373.011.002-.009h1.822v-.267l-1.627-.448.256-.94v-1.577l-.309-1.421-1.179 2.798c-.003.008-.008.015-.012.023-.008.018-.018.035-.028.053-.014.026-.027.053-.044.077a.8.8 0 01-.086.106l-.005.006a.804.804 0 01-.153.127l-.694.433a.862.862 0 01-.127.065l-1.876.758-.02-.002-1.698.685.004.01-.125.049c-.64.21-.987.062-1.229-.324l4.645-2.902c.252-1.229 1.005-4.894 1.088-5.419a1.402 1.402 0 01.588-.931l-.004-.014S7.763 6.113 10 6.113c2.41 0 3.683.978 3.683.978l-.004.014a1.393 1.393 0 01.588.931c.083.525.836 4.19 1.088 5.42z",
  id: "a"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#969696",
  xlinkHref: "#a"
});

var SvgRecovery = function SvgRecovery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fillOpacity: 0.7,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecovery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recovery.07c12937.svg";
export { ForwardRef as ReactComponent };